import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const BarnAIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M5.32208 17.2286H0.771429V7.62857L9 0.771429L17.2286 7.62857V17.2286H12.6779M5.32208 17.2286V11.9922H12.6779V17.2286M5.32208 17.2286H12.6779M10.3714 7.62857C10.3714 8.38599 9.75742 9 9 9C8.24258 9 7.62857 8.38599 7.62857 7.62857C7.62857 6.87115 8.24258 6.25714 9 6.25714C9.75742 6.25714 10.3714 6.87115 10.3714 7.62857Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

BarnAIcon.displayName = 'BarnAIcon';
